import React, { Component } from "react";
import {
  profile,
  branch,
  alert,
  total,
  float,
  toFixed,
  format_date,
  random_charactor,
  GET,
  POST,
  PUT,
  DELETE,
  loading,
  Status,
  params,
  required,
  DatePicker,
  Select,
  BtnIcon,
  Swal,
  Pagination,
  Switch,
  Navbar,
  Modal,
  Resizer,
} from "../../../components/CustomComponent.js";

import { report_receipt_tax, report_receipt, report_contract } from "../../../components/Report.js";
export default class Payments extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data_sale: [],
      data_customer: [],
      data_bank: [],
      data_product: [],

      tab: "normal",

      date: "",
      due_date: format_date(new Date(), "yyyy-mm-dd", "en"),
      customer_id: "",
      withdrawal_type: "",
      customer_name: "",
      customer_address: "",
      customer_phone: "",
      payment_type: "",
      tax_number: "",
      receipt_type: "",
      is_delivery: false,
      ref_number: "",

      transaction_list: [],
      transaction_list_vat: [],

      is_vat: false,
      discount: 0,
      delivery_cost: 0,

      amount_deposit: 0,
      amount_deposit_need: 0,
      total_pay: 0,

      remark: "",

      // เงินสด
      cash_amount: 0,
      // เงินโอน
      transfer_amount: 0,
      transfer_bank_account: "",
      transfer_date: "",
      transfer_time: "",
      // เครดิต
      credit_amount: 0,
      credit_bank_account: "",
      credit_date: "",
      check_number: "",
    };
  }

  async componentDidMount() {
    loading(true);
    await this.Get();
    if (params("id")) {
      await this.GetByID(params("id"));
    }

    loading(false);
  }
  Get = async () => {
    let data_customer,
      data_sale,
      data_bank,
      data_product,
      transfer_bank_account;
    let [result_customer, result_sale, result_bank, result_product] =
      await Promise.all([
        GET("admin/setting/customers/list", { page: 0, data_search: "" }),
        GET("admin/sales/list", {
          page: 0,
          status_code: "รอชำระ,รอสั่งสินค้า",
        }),
        GET("admin/setting/banks/list", { page: 0, data_search: "" }),
        GET("admin/setting/spare-parts/list", { page: 0, data_search: "" }),
      ]);
    if (result_customer?.status) {
      
      data_customer = result_customer.data.map((e) => ({
        value: e.uid,
        label: `${e.full_name}${e.customer_code ? ` ${e.customer_code} | ` : ""}${e.phone ? ` (${e.phone}) ` : ""} ${
            e.address ? ` | ${e.address}` : ""
          }`,
        address: e.address,
        full_name: e.full_name,
        phone: e.phone,
      }));
    }
    if (result_sale?.status) {
      data_sale = result_sale.data
        .filter((e) => e.withdrawal_type !== "เบิกแจ้งซ่อม")
        .map((e) => ({
          value: e.uid,
          label: e.document_no,
        }));
    }
    if (result_bank?.status) {
      data_bank = result_bank.data
        .map((e) => ({
          value: e.uid,
          label: `${e.bank_name} : ${e.account_number} (${e.account_name})`,
          is_default: e.is_default, // เก็บไว้ใช้ sort
        }))
        .sort((a, b) => (b.is_default === true) - (a.is_default === true));
    }
    if (result_product?.status) {
      data_product = result_product.data.map((e) => ({
        value: e.uid,
        label: `${e.product_code} ${e.product_name}`,
        id: e.id,
        warehouse_id: e.warehouse?.uid || "",
        unit_name: e.unit_name,
        is_serial_number: e.is_serial_number,
        product_code: e.product_code,
        product_name: e.product_name,
        sale_price: e.sale_price,
      }));
    }
    this.setState({
      data_customer,
      data_sale,
      data_bank,
      data_product,
    });
  };
  calcBilled = () => {
    const { transaction_list, transaction_list_vat, discount, vat } =
      this.state;
    let total = 0;
    if (transaction_list_vat.length > 0) {
      transaction_list_vat.forEach((item) => {
        const qty = Number(item.qty ?? 0);
        const unitPrice = Number(item.unit_price ?? 0);
        const itemDiscount = Number(item.discount ?? 0);
        total += qty * (unitPrice - itemDiscount);
      });
    } else {
      transaction_list.forEach((item) => {
        const qty = Number(item.qty ?? 0);
        const unitPrice = Number(item.unit_price ?? 0);
        const itemDiscount = Number(item.discount ?? 0);
        total += qty * (unitPrice - itemDiscount);
      });
    }
    if (isNaN(total)) total = 0;
    const net = total - Number(discount ?? 0);
    return net + Number(vat ?? 0);
  };
  calcOutstanding = () => {
    return this.calcBilled() - Number(this.state.total_pay ?? 0);
  };
  normalizeAmount = (value) => Number(toFixed(value).replaceAll(",", ""));
  calcDefaultPaymentNeed = (billed, totalPay, amountDeposit) => {
    if (totalPay < amountDeposit) {
      return amountDeposit - totalPay;
    }
    return Math.max(0, billed - totalPay);
  };
  GetByID = async (id) => {
    const { data_product } = this.state;
    loading(true);
    let result = await GET("admin/sales/list", { uid: id });
    
    let item = result.data;
    this.setState({
      ...item,
      uid: id,
      date: item?.created_at ? item?.created_at.split("T")[0] : "",
      due_date: item?.due_date
        ? item?.due_date
        : item?.payment_type === "ชำระเงินเชื่อ"
        ? format_date(
            new Date(
              new Date(item?.created_at).setMonth(
                new Date(item?.created_at).getMonth() + 1
              )
            ),
            "yyyy-mm-25",
            "en"
          )
        : format_date(new Date(), "yyyy-mm-dd", "en"),
      // customer
      customer_id: item?.customer.uid,
      customer_name: item?.customer.full_name,
      address: item?.customer.address,
      phone_number: item?.customer.phone,
      tax_number: item?.customer.tax_number,

      withdrawal_type: item?.withdrawal_type,
      payment_type: item?.payment_type,
      receipt_type: item?.receipt_type,

      transaction_list: item?.transaction_list,
      transaction_list_vat: item?.transaction_list_vat?.map((e) => ({
        ...e,
        product_id:
          data_product.find((p) => p.product_code === e.product_code)?.value ||
          "",
      })),
      is_vat: item?.is_vat,
      discount: item?.discount,

      amount_deposit: Number(item?.amount_deposit),
      total_pay: Number(item?.total_pay),
      ref_number: item?.ref_number,
    }, () => {
      if (item?.is_vat && !Number(item?.vat)) {
        this.calVat();
      }
      const billed = this.calcBilled();
      const totalPay = Number(item?.total_pay);
      const amountDeposit = Number(item?.amount_deposit);
      this.setState({
        amount_deposit_need: this.calcDefaultPaymentNeed(
          billed,
          totalPay,
          amountDeposit
        ),
      });
    });

    loading(false);
  };
  CreateUpdate = async () => {
    const {
      data_bank,
      uid,
      warehouse_id,
      ref_number,
      user_id,
      customer_id,
      discount,
      is_vat,
      vat,
      delivery_cost,
      status,
      remark,
      due_date,
      withdrawal_type,
      payment_type,
      receipt_type,
      transaction_list,
      transaction_list_vat,
      amount_deposit,
      amount_deposit_need,
      cash_amount,
      transfer_amount,
      credit_amount,
      total_pay,
      transfer_bank_account,
      transfer_date,
      transfer_time,
      credit_bank_account,
      credit_date,
      check_number,
      customer_name,
      customer_address,
      customer_phone,
    } = this.state;
    if (!customer_id.trim()) {
      alert("", "warning", "แจ้งเตือน", "กรุณาเลือกลูกค้า");
      return;
    }
    if (!due_date) {
      alert("", "warning", "แจ้งเตือน", "กรุณาเลือกวันที่ครบกำหนด");
      return;
    }
    if (!withdrawal_type) {
      alert("", "warning", "แจ้งเตือน", "กรุณาเลือกประเภทการซื้อ");
      return;
    }
    if (!payment_type) {
      alert("", "warning", "แจ้งเตือน", "กรุณาเลือกประเภทการชำระ");
      return;
    }
    if (!receipt_type) {
      alert("", "warning", "แจ้งเตือน", "กรุณาเลือกประเภทใบเสร็จ");
      return;
    }

    const outstanding = this.normalizeAmount(this.calcOutstanding());
    const payment_need = this.normalizeAmount(amount_deposit_need);
    const total_pay_amount = this.normalizeAmount(
      Number(cash_amount) + Number(transfer_amount) + Number(credit_amount)
    );

    let _status = status;
    if (payment_type === "ชำระมัดจำ" || payment_type === "ชำระเงินทันที") {
      if (payment_need <= 0) {
        alert(
          "",
          "warning",
          "แจ้งเตือน",
          "ยอดเงินที่ต้องการชำระต้องมากกว่า 0 บาท"
        );
        return;
      }

      if (total_pay_amount !== payment_need) {
        alert(
          "",
          "warning",
          "แจ้งเตือน",
          "ยอดชำระไม่เท่ากับยอดเงินที่ต้องการชำระ"
        );
        return;
      }
    }
    if (payment_type !== "ชำระครบแล้ว") {
      if (total_pay_amount > 0 && total_pay_amount > outstanding + 0.01) {
        alert("", "warning", "แจ้งเตือน", "ยอดชำระเกินมูลค่าเต็มจำนวนสั่งซื้อ");
        return;
      }

      if (_status === "รอชำระ") {
        if (total_pay_amount === 0) {
          _status = "รอชำระ";
        } else if (outstanding <= total_pay_amount) {
          _status = "เสร็จสิ้น";
        } else {
          _status = "รอชำระ";
        }
      } else {
        if (outstanding <= total_pay_amount) {
          _status = "เสร็จสิ้น";
        } else {
          _status = "รอชำระ";
        }
      }
      if (withdrawal_type === "รอสั่งสินค้า") {
        // if (toFixed(total_pay_amount, 2) === toFixed(grandTotal, 2)) {
        //   _status = "เสร็จสิ้น";
        // } else {
        _status = "รอสั่งสินค้า";
        // }
      }

      if (payment_type === "ชำระเงินเชื่อ") {
        _status = "ใบแจ้งหนี้";
      }
    } else {
      _status = "เสร็จสิ้น";
    }

    let _amount = 0;
    transaction_list?.forEach((item) => {
      _amount +=
        Number(item.qty) * (Number(item.unit_price) - Number(item.discount));
    });
    loading(true);
    let body = {
      customer_id: customer_id,
      customer_name: customer_name,
      customer_address: customer_address,
      customer_phone: customer_phone,
      due_date: due_date,
      withdrawal_type: withdrawal_type,
      payment_type: payment_type,
      receipt_type: receipt_type,
      amount: _amount,
      amount_deposit: amount_deposit,
      is_vat,

      vat: Number(vat),

      transaction_list: transaction_list,
      transaction_list_vat: transaction_list_vat,

      status: _status,
      discount: Number(discount),

      payment: {
        cash_amount: Number(cash_amount),
        transfer_amount: Number(transfer_amount),
        transfer_bank_account: transfer_bank_account,
        transfer_date: transfer_date || null,
        transfer_time: transfer_time,
        credit_amount: Number(credit_amount),
        credit_bank_account: credit_bank_account,
        credit_date: credit_date || null,
        check_number: check_number,
        change: 0,
      },
      remark: remark,
    };

    

    let result = await PUT("admin/sales/update/" + uid, body);
    if (result?.status) {
      // alert("/payment/order-lists", "success");
      
      const _transfer_bank_account = data_bank.find(e=>e.value === transfer_bank_account)
      const _credit_bank_account = global.bank.find(e=>e.value === credit_bank_account)
      Swal.fire({
        title: "พิมพ์เอกสาร",
        text: "",
        html: `
          <div class="w-100">
            <button id="report-receipt-tax" class="btn btn-outline-dark w-100 mb-3 text-start">
              <span class="icon me-2">&#xf15b;</span>
              ใบเสร็จรับเงิน/ใบกำกับภาษี
            </button>
            <button id="report-receipt" class="btn btn-outline-dark w-100 mb-3 text-start">
              <span class="icon me-2">&#xf15b;</span>
              ใบเสร็จรับเงิน
            </button>
            <button id="report-contract" class="btn btn-outline-dark w-100 mb-3 text-start">
              <span class="icon me-2">&#xf15b;</span>
              ใบสัญญายืมหรือซื้อสินค้าชั่วคราว
            </button>
          </div>`,
        showConfirmButton: false,
        showCancelButton: false,
        showCloseButton: true,
        didOpen: () => {
          document.getElementById("report-receipt-tax").addEventListener("click", () => {
          report_receipt_tax(uid, {
            cash_amount: cash_amount,
            transfer_amount: transfer_amount,
            transfer_bank_account: _transfer_bank_account?.label || "",
            transfer_date: transfer_date,
            transfer_time: transfer_time,
            credit_amount: credit_amount,
            credit_bank_account: _credit_bank_account?.label || "",
            credit_date: credit_date,
            check_number: check_number,
          });
        });
          document.getElementById("report-receipt").addEventListener("click", () => {
          report_receipt(uid, {
            cash_amount: cash_amount,
            transfer_amount: transfer_amount,
            transfer_bank_account: _transfer_bank_account?.label || "",
            transfer_date: transfer_date,
            transfer_time: transfer_time,
            credit_amount: credit_amount,
            credit_bank_account: _credit_bank_account?.label || "",
            credit_date: credit_date,
            check_number: check_number,
          });
        });
          document.getElementById("report-contract").addEventListener("click", () => {
            report_contract(uid, {
              cash_amount,
              transfer_amount,
              transfer_bank_account,
              transfer_date,
              transfer_time,
              credit_amount,
              credit_bank_account,
              credit_date,
              check_number,
            });
          });
        },
      }).then((res) => {
        if (res.dismiss) {
          window.location.href = "/payment/order-lists";
        }
      });
    } else {
      alert(
        "",
        "warning",
        "แจ้งเตือน",
        result?.message || "เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง"
      );
    }
    loading(false);
  };
  Delete = async (id) => {
    if (
      await alert(
        "",
        "warning",
        "ลบข้อมูล",
        "ยืนยันการลบรายการนี้หรือไม่ ?",
        "ลบข้อมูล",
        "ยกเลิก"
      )
    ) {
      loading(true);
      let result = await DELETE("banks/" + id, null);
      if (result?.status) {
        alert("#", "success");
      }
      loading(false);
    }
  };
  calVat = () => {
    const { transaction_list, discount, is_vat } = this.state;
    let total = 0;
    const vatRate = is_vat ? 0.07 : 0;

    transaction_list?.forEach((item) => {
      const qty = Number(item.qty ?? 0);
      const unitPrice = Number(item.unit_price ?? 0);
      const itemDiscount = Number(item.discount ?? 0);
      total += qty * (unitPrice - itemDiscount);
    });

    if (isNaN(total)) total = 0;

    const billDiscount = Number(discount ?? 0); // ส่วนลดทั้งบิล
    const net = total - billDiscount;

    const vat = net * vatRate;
    this.setState({ vat: Number(toFixed(vat).replaceAll(",", "")) });
  }
  render() {
    const {
      data_sale,
      data_customer,
      data_bank,
      data_product,

      tab,

      uid,
      date,
      due_date,
      customer_id,

      withdrawal_type,
      customer_name,
      customer_address,
      customer_phone,
      payment_type,
      tax_number,
      receipt_type,
      is_delivery,
      ref_number,

      transaction_list,
      transaction_list_vat,
      is_vat,
      discount,
      vat,
      remark,

      amount_deposit,
      amount_deposit_need,
      total_pay,

      cash_amount,
      transfer_amount,

      transfer_bank_account,
      transfer_date,
      transfer_time,

      credit_amount,
      credit_bank_account,
      credit_date,
      check_number,
    } = this.state;
    return (
      <div className="w-100 min-vh-100">
        <Navbar />
        <div className="body p-3">
          <div className="d-flex justify-content-between mb-2">
            <h4 className="fw-bold mb-3 me-3">ชำระเงิน</h4>
          </div>
          <div className="rounded-4 bg-white p-3 mb-3">
            <div className="row mb-3">
              <div className="col-6 col-md-4 mb-2">
                <div className="wpx-150 mb-1">เลขรายการสั่งซื้อ</div>
                <Select
                  className="form-control"
                  placeholder="เลขรายการสั่งซื้อ..."
                  options={data_sale}
                  onChange={(e) => {
                    this.setState({ uid: e });
                    if (e) this.GetByID(e);
                  }}
                  value={uid}
                  disabled={params("type") === "view"}
                />
              </div>
              <div className="col-6 col-md-4 mb-2">
                <div className="wpx-150 mb-1">วันที่ขายสินค้า</div>
                <input
                  type="date"
                  className="form-control"
                  placeholder="วันที่ขายสินค้า..."
                  onChange={(e) => {
                    this.setState({ date: e.target.value });
                  }}
                  value={date}
                  disabled
                />
              </div>
              <div className="col-6 col-md-4 mb-2">
                <div className="wpx-150 mb-1">ลูกค้า</div>
                <Select
                  options={data_customer}
                  className="form-control"
                  placeholder="ลูกค้า..."
                  onChange={(e, i) => {
                    this.setState({
                      customer_id: e,
                      customer_name: i.full_name,
                      customer_address: i.address,
                      customer_phone: i.phone,
                    });
                  }}
                  value={customer_id}
                  disabled={params("type") === "view"}
                />
              </div>
              <div className="col-6 col-md-4 mb-2">
                <div className="wpx-150 mb-1">ชื่อลูกค้า</div>
                <input
                  type="text"
                  className="form-control"
                  placeholder="ชื่อลูกค้า..."
                  onChange={(e) => {
                    this.setState({ customer_name: e.target.value });
                  }}
                  value={customer_name}
                  disabled={params("type") === "view"}
                />
              </div>
              <div className="col-6 col-md-4 mb-2">
                <div className="wpx-150 mb-1">ที่อยู่</div>
                <input
                  type="text"
                  className="form-control"
                  placeholder="ที่อยู่..."
                  onChange={(e) => {
                    this.setState({ customer_address: e.target.value });
                  }}
                  value={customer_address}
                  disabled={params("type") === "view"}
                />
              </div>
              <div className="col-6 col-md-4 mb-2">
                <div className="wpx-150 mb-1">เบอร์โทรศัพท์</div>
                <input
                  type="text"
                  className="form-control"
                  placeholder="เบอร์โทรศัพท์..."
                  onChange={(e) => {
                    if (!float(e.target.value)) return;
                    this.setState({ customer_phone: e.target.value });
                  }}
                  value={customer_phone}
                  maxLength={10}
                  disabled={params("type") === "view"}
                />
              </div>
              <div className="col-6 col-md-4 mb-2">
                <div className="wpx-150 mb-1">ครบกำหนดชำระ</div>
                <input
                  type="date"
                  className="form-control"
                  placeholder="ครบกำหนดชำระ..."
                  onChange={(e) => {
                    this.setState({ due_date: e.target.value });
                  }}
                  value={due_date}
                  disabled={params("type") === "view"}
                />
              </div>
              <div className="col-6 col-md-4 mb-2">
                <div className="wpx-150 mb-1">ประเภทการเบิก</div>
                <select
                  className="form-control"
                  onChange={(e) => {
                    this.setState({ withdrawal_type: e.target.value });
                  }}
                  value={withdrawal_type}
                  disabled={
                    Number(total_pay) !== 0 || params("type") === "view"
                  }
                >
                  <option value="">เลือกประเภท</option>
                  <option value="ขายหน้าร้าน">ขายหน้าร้าน</option>
                  <option value="เบิกแจ้งซ่อม">เบิกแจ้งซ่อม</option>
                  <option value="รอสั่งสินค้า">รอสั่งสินค้า</option>
                </select>
              </div>
              <div className="col-6 col-md-4 mb-2">
                <div className="wpx-150 mb-1">รูปแบบบิลชำระ</div>
                <select
                  className="form-control"
                  onChange={(e) => {
                    this.setState({ payment_type: e.target.value });
                  }}
                  value={payment_type}
                  disabled={
                    Number(total_pay) !== 0 || params("type") === "view"
                  }
                >
                  <option value="">เลือกรูปแบบบิลชำระ</option>
                  <option value="ชำระเงินทันที">ชำระเงินทันที</option>
                  <option value="ชำระมัดจำ">ชำระมัดจำ</option>
                  <option value="ชำระเงินเชื่อ">ชำระเงินเชื่อ</option>
                  <option value="ชำระครบแล้ว">ชำระครบแล้ว</option>
                </select>
              </div>
              <div className="col-6 col-md-4 mb-2">
                <div className="wpx-150 mb-1">ประเภทใบเสร็จ</div>
                <select
                  className="form-control"
                  onChange={(e) => {
                    this.setState({
                      receipt_type: e.target.value,
                      is_vat: e.target.value === "ต้องการ Vat" ? true : false,
                    },() => {
                      this.calVat()
                    });
                  }}
                  value={receipt_type}
                  disabled={params("type") === "view"}
                >
                  <option value="">เลือกรูปแบบบิลชำระ</option>
                  <option value="ไม่ต้องการ Vat">ไม่ต้องการ Vat</option>
                  <option value="ต้องการ Vat">ต้องการ Vat</option>
                  <option value="บันทึกออเดอร์">บันทึกออเดอร์</option>
                </select>
              </div>
              {ref_number && (
              <div className="col-6 col-md-4 mb-2">
                <div className="wpx-150 mb-1">ใบคืนสินค้าอ้างอิง</div>
                <div>{ref_number}</div>
              </div>
              )}
              {is_delivery && (
                <div className="col-6 col-md-4 mb-2">
                  <div className="hpx-30"></div>
                  <div className="text-primary">สินค้าส่งปลายทาง</div>
                </div>
              )}
            </div>
            <div className="d-flex mb-3">
              <div className="border-1 border-secondary rounded-4 p-1 d-flex bg-light">
                <button
                  className={`btn ${
                    tab === "normal" ? "btn-dark" : "btn-light"
                  } px-3`}
                  onClick={async () => {
                    this.setState({ tab: "normal" });
                  }}
                >
                  รายการขายปกติ
                </button>
                <div style={{ width: 4 }}></div>
                <button
                  className={`btn ${
                    tab === "vat" ? "btn-dark" : "btn-light"
                  } px-3`}
                  onClick={async () => {
                    this.setState({ tab: "vat" });
                  }}
                >
                  รายการขายมี Vat
                </button>
              </div>
            </div>
            {/* รายการขายปกติ */}
            {tab === "normal" && (
              <div>
                <div className="table-responsive">
                  <table className="table rounded-3 overflow-hidden table-hover">
                    <thead>
                      <tr>
                        <td className="text-nowrap">ลำดับ</td>
                        <td className="text-nowrap">รหัส/ชื่อสินค้า</td>
                        <td className="text-nowrap">Serial No.</td>
                        <td className="text-nowrap text-center">จำนวน</td>
                        <td className="text-nowrap text-center">ราคา/หน่วย</td>
                        <td className="text-nowrap text-center">ส่วนลด</td>
                        <td className="text-nowrap text-end">
                          ราคาหลังหักส่วนลด
                        </td>
                        <td className="text-nowrap text-end">มูลค่ารวม</td>
                      </tr>
                    </thead>
                    <tbody>
                      {transaction_list?.map((item, index) => (
                        <tr>
                          <td className="text-nowrap">{index + 1}</td>
                          <td className="text-nowrap">
                            {item.product_code} {item.product_name}{" "}
                            {item.remark}
                          </td>
                          <td className="text-nowrap">
                            {item.serial_number || ""}
                          </td>
                          <td className="text-nowrap">{toFixed(item.qty)}</td>
                          <td className="text-nowrap">
                            {toFixed(item.unit_price)}
                          </td>
                          <td className="text-nowrap">
                            {params("type") === "view" ? (
                              item.discount
                            ) : (
                              <input
                                type="text"
                                className="form-control wpx-100 mx-1 text-end"
                                onChange={(e) => {
                                  if (!float(e.target.value)) return;
                                  transaction_list[index].discount = e.target.value;
                                  this.setState({ transaction_list },() => {
                                    // this.calVat()
                                  });
                                }}
                                value={item.discount}
                                disabled={payment_type === "ชำระครบแล้ว"}
                              />
                            )}
                          </td>
                          <td className="text-nowrap text-end">
                            {toFixed(
                              Number(item.unit_price) - Number(item.discount)
                            ) || "0.00"}
                          </td>
                          <td className="text-nowrap text-end">
                            {toFixed(
                              Number(item.qty) *
                                (Number(item.unit_price) -
                                  Number(item.discount))
                            ) || "0.00"}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div className="rounded-4 bg-white p-3">
                  <div className="row">
                    <div className="col-12 col-md-6 mb-2">
                      <span className="mb-3">หมายเหตุ</span>
                      <textarea
                        className="form-control"
                        onChange={(e) => {
                          this.setState({ remark: e.target.value });
                        }}
                        value={remark}
                        rows={7}
                        disabled={params("type") === "view"}
                      />
                    </div>
                    <div className="col-12 col-md-6 mb-2">
                      <div className="d-flex align-items-center justify-content-between mb-3">
                        <b>รวมเป็นเงิน</b>
                        <span>
                          {(() => {
                            let total = 0;
                            transaction_list?.forEach((item) => {
                              total += Number(item.qty) * (Number(item.unit_price) - Number(item.discount));
                            });
                            if (isNaN(total)) total = 0;
                            return `${toFixed(total || 0)} บาท`;
                          })()}
                        </span>
                      </div>
                      <div className="d-flex align-items-center justify-content-between mb-3">
                        <b>ส่วนลด</b>
                        <div className="d-flex align-items-center">
                          {params("type") === "view" ? (
                            discount
                          ) : (
                            <input
                              type="text"
                              className="form-control me-2 text-end wpx-120"
                              onChange={(e) => {
                                if (!float(e.target.value)) return;
                                this.setState({ discount: e.target.value },() => {
                                  // this.calVat()
                                });
                              }}
                              value={discount}
                              disabled={payment_type === "ชำระครบแล้ว"}
                            />
                          )}{" "}
                          <span>บาท</span>
                        </div>
                      </div>
                      <div className="d-flex align-items-center justify-content-between mb-3">
                        <b>ราคาหลังหักส่วนลด</b>
                        <span>
                          {(() => {
                            let total = 0;
                            transaction_list?.forEach((item) => {
                              total += Number(item.qty) * (Number(item.unit_price) - Number(item.discount));
                            });
                            if (isNaN(total)) total = 0;
                            return `${toFixed(total - discount || 0)}`;
                          })()}{" "}
                          บาท
                        </span>
                      </div>
                      <div className="d-flex align-items-center justify-content-between mb-3">
                        <b>ภาษีมูลค่าเพิ่ม 7%</b>
                        <div className="d-flex align-items-center">
                          {receipt_type === "ไม่ต้องการ Vat" && (
                            <div className="me-3"><BtnIcon type="approve" onClick={() => {
                              const _vat = Number(toFixed(transfer_amount * 0.07).replaceAll(",", ""));
                              this.setState({ vat: _vat }, () => {
                                const outstanding = Number(toFixed(this.calcOutstanding()).replaceAll(",", ""));
                                this.setState({ amount_deposit_need: outstanding });
                              });
                            }}/></div>
                          )}
                          
                           {/* {params("type") === "view" ? (
                            vat
                          ) : (
                            <input
                              type="text"
                              className="form-control me-2 text-end wpx-120"
                              onChange={(e) => {
                                if (!float(e.target.value)) return;
                                this.setState({ vat: e.target.value });
                              }}
                              value={vat}
                              disabled={payment_type === "ชำระครบแล้ว"}
                            />
                          )} */}
                          
                           <span>{vat}{" "}บาท</span>
                        </div>
                      </div>
                      <div className="d-flex align-items-center justify-content-between mb-3">
                        <b>ค่ามัดจำ (ตามสัญญา)</b>
                        <span>{toFixed(amount_deposit)} บาท</span>
                      </div>
                      <div className="d-flex align-items-center justify-content-between mb-3">
                        <b>มูลค่าที่ชำระแล้ว</b>
                        <span>{toFixed(total_pay)} บาท</span>
                      </div>
                      <hr />
                      <div className="d-flex align-items-center justify-content-between mb-3">
                        <b>ยอดค้างชำระ</b>
                        <h4 className="fw-bold text-success">
                          {toFixed(this.calcOutstanding())} บาท
                        </h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {tab === "vat" && (
              <div>
                <div>
                  <table className="table rounded-3 table-hover">
                    <thead>
                      <tr>
                        <td className="text-nowrap">ลำดับ</td>
                        <td className="text-nowrap">รหัส/ชื่อสินค้า</td>
                        <td className="text-nowrap">Serial No.</td>
                        <td className="text-nowrap text-center">จำนวน</td>
                        <td className="text-nowrap text-center">ราคา/หน่วย</td>
                        <td className="text-nowrap text-center">ส่วนลด</td>
                        <td className="text-nowrap text-end">
                          ราคาหลังหักส่วนลด
                        </td>
                        <td className="text-nowrap text-end">มูลค่ารวม</td>
                      </tr>
                    </thead>
                    <tbody>
                      {transaction_list_vat?.map((item, index) => (
                        <tr>
                          <td className="text-nowrap">{index + 1}</td>
                          <td className="text-nowrap">
                            <input
                              type="text"
                              className="form-control mx-1"
                              onChange={(e) => {
                                transaction_list_vat[index].product_name =
                                  e.target.value;
                                this.setState({ transaction_list_vat });
                              }}
                              value={item.product_name}
                              disabled={params("type") === "view"}
                            />
                          </td>
                          <td className="text-nowrap">
                            <input
                              type="text"
                              className="form-control mx-1"
                              onChange={(e) => {
                                transaction_list_vat[index].serial_number =
                                  e.target.value;
                                this.setState({ transaction_list_vat });
                              }}
                              value={item.serial_number}
                              disabled={params("type") === "view"}
                            />
                          </td>
                          <td className="text-nowrap">
                            {params("type") === "view" ? (
                              item.qty
                            ) : (
                              <div className="d-flex">
                                {!params("uid") && (
                                  <button
                                    className="btn btn-primary wpx-30"
                                    onClick={async () => {
                                      if (item.qty <= 1) {
                                        if (
                                          await alert(
                                            "",
                                            "info",
                                            "ยืนยัน",
                                            "ยืนยันการลบข้อมูลนี้หรือไม่",
                                            "ลบข้อมูล",
                                            "ยกเลิก"
                                          )
                                        ) {
                                          this.setState({
                                            transaction_list_vat:
                                              transaction_list_vat.filter(
                                                (_, i) => i !== index
                                              ),
                                          });
                                        }
                                      } else {
                                        transaction_list_vat[index].qty =
                                          Math.max(0, item.qty - 1);
                                        this.setState({ transaction_list_vat });
                                      }
                                    }}
                                  >
                                    -
                                  </button>
                                )}
                                <input
                                  type="text"
                                  className="form-control wpx-60 mx-1 text-center"
                                  onChange={(e) => {
                                    if (!float(e.target.value)) return;
                                    transaction_list_vat[index].qty = Number(
                                      e.target.value
                                    );
                                    this.setState({ transaction_list_vat });
                                  }}
                                  value={item.qty}
                                />
                                {!params("uid") && (
                                  <button
                                    className="btn btn-primary wpx-30"
                                    onClick={() => {
                                      transaction_list_vat[index].qty =
                                        Math.max(0, item.qty + 1);
                                      this.setState({ transaction_list_vat });
                                    }}
                                  >
                                    +
                                  </button>
                                )}
                              </div>
                            )}
                          </td>
                          <td className="text-nowrap">
                            <input
                              type="text"
                              className="form-control wpx-100 mx-1 text-end"
                              onChange={(e) => {
                                if (!float(e.target.value)) return;
                                transaction_list_vat[index].unit_price =
                                  e.target.value;
                                this.setState({ transaction_list_vat });
                              }}
                              onKeyUp={(e) => {
                                if (e.key === "Enter") {
                                  if (
                                    index ===
                                    transaction_list_vat.length - 1
                                  ) {
                                    this.setState(
                                      {
                                        transaction_list_vat: [
                                          ...transaction_list_vat,
                                          {
                                            uid: "",
                                            type: "",
                                            product_id: "",
                                            product_name: "",
                                            product_code: "",
                                            product_type: "",
                                            serial_number: "",
                                            warehouse_id: "",
                                            warehouse_name: "",
                                            category_id: "",
                                            category_name: "",
                                            qty: 1,
                                            unit_name: "",
                                            cause: "",
                                            discount: "",
                                            sale_price: "",
                                            cost_price: "",
                                            unit_price: "",
                                            amount: "",
                                          },
                                        ],
                                      },

                                      () => {
                                        try {
                                          const index =
                                            transaction_list_vat.length - 1;
                                          document
                                            .getElementById("price-" + index)
                                            ?.focus();
                                        } catch (e) {
                                          console.error(
                                            "Error focusing on product input:",
                                            e
                                          );
                                        }
                                      }
                                    );
                                  } else {
                                    try {
                                      document
                                        .getElementById("price-" + (index + 1))
                                        .focus();
                                    } catch (e) {
                                      console.error(
                                        "Error focusing on product input:",
                                        e
                                      );
                                    }
                                  }
                                }
                              }}
                              value={item.unit_price}
                              id={`price-${index}`}
                              disabled={params("type") === "view"}
                            />
                          </td>
                          <td className="text-nowrap">
                            <input
                              type="text"
                              className="form-control wpx-100 mx-1 text-end"
                              onChange={(e) => {
                                if (!float(e.target.value)) return;
                                transaction_list_vat[index].discount =
                                  e.target.value;
                                this.setState({ transaction_list_vat });
                              }}
                              value={item.discount}
                              disabled={params("type") === "view"}
                            />
                          </td>
                          <td className="text-nowrap text-end">
                            {toFixed(
                              Number(item.unit_price) - Number(item.discount)
                            ) || "0.00"}
                          </td>
                          <td className="text-nowrap text-end">
                            {toFixed(
                              Number(item.qty) *
                                (Number(item.unit_price) -
                                  Number(item.discount))
                            ) || "0.00"}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                {params("type") !== "view" && (
                  <div className="d-flex">
                    <button
                      className="btn btn-dark px-3 me-2 mb-2"
                      // disabled={Number(total_pay) > 0}
                      onClick={() => {
                        this.setState(
                          {
                            transaction_list_vat: [
                              ...transaction_list_vat,
                              {
                                uid: "",
                                type: "",
                                product_id: "",
                                product_name: "",
                                product_code: "",
                                product_type: "",
                                serial_number: "",
                                warehouse_id: "",
                                warehouse_name: "",
                                category_id: "",
                                category_name: "",
                                qty: 1,
                                unit_name: "",
                                cause: "",
                                discount: "",
                                sale_price: "",
                                cost_price: "",
                                unit_price: "",
                                amount: "",
                              },
                            ],
                          },
                          () => {
                            try {
                              const index = transaction_list_vat.length - 1;
                              document
                                .getElementById("price-" + index)
                                ?.focus();
                            } catch (e) {
                              console.error(
                                "Error focusing on product input:",
                                e
                              );
                            }
                          }
                        );
                      }}
                    >
                      เพิ่มรายการ
                    </button>
                  </div>
                )}
                <div className="rounded-4 bg-white p-3">
                  <div className="row">
                    <div className="col-12 col-md-6 mb-2"></div>
                    <div className="col-12 col-md-6 mb-2">
                      <div className="d-flex align-items-center justify-content-between mb-3">
                        <b>รวมเป็นเงิน</b>
                        <span>
                          {(() => {
                            let total = 0;
                            transaction_list_vat.forEach((item) => {
                              total +=
                                Number(item.qty) *
                                (Number(item.unit_price) -
                                  Number(item.discount));
                            });
                            if (isNaN(total)) total = 0;
                            return `${toFixed(total || 0)} บาท`;
                          })()}
                        </span>
                      </div>
                      <div className="d-flex align-items-center justify-content-between mb-3">
                        <b>ส่วนลด</b>
                        <span>{toFixed(discount || 0)} บาท</span>
                      </div>
                      <div className="d-flex align-items-center justify-content-between mb-3">
                        <b>ราคาหลังหักส่วนลด</b>
                        <span>
                          {(() => {
                            let total = 0;
                            transaction_list_vat.forEach((item) => {
                              total +=
                                Number(item.qty) *
                                (Number(item.unit_price) -
                                  Number(item.discount));
                            });
                            if (isNaN(total)) total = 0;
                            return `${toFixed(total - discount || 0)}`;
                          })()}{" "}
                          บาท
                        </span>
                      </div>
                      <div className="d-flex align-items-center justify-content-between mb-3">
                        <b>ภาษีมูลค่าเพิ่ม 7%</b>
                        <span>
                          {(() => {
                            let total = 0;
                            const vatRate = is_vat ? 0.07 : 0;

                            transaction_list_vat.forEach((item) => {
                              const qty = Number(item.qty ?? 0);
                              const unitPrice = Number(item.unit_price ?? 0);
                              const itemDiscount = Number(item.discount ?? 0);
                              total += qty * (unitPrice - itemDiscount);
                            });

                            if (isNaN(total)) total = 0;

                            const billDiscount = Number(discount ?? 0); // ส่วนลดทั้งบิล
                            const net = total - billDiscount;

                            const vat = net * vatRate;

                            return `${toFixed(vat)} บาท`;
                          })()}
                        </span>
                      </div>
                      <div className="d-flex align-items-center justify-content-between mb-3">
                        <b>ค่ามัดจำ (ตามสัญญา)</b>
                        <span>{toFixed(amount_deposit)} บาท</span>
                      </div>
                      <div className="d-flex align-items-center justify-content-between mb-3">
                        <b>มูลค่าที่ชำระแล้ว</b>
                        <span>{toFixed(total_pay)} บาท</span>
                      </div>
                      <hr />
                      <div className="d-flex align-items-center justify-content-between mb-3">
                        <b>ยอดค้างชำระ</b>
                        <h4 className="fw-bold text-success">
                          {toFixed(this.calcOutstanding())} บาท
                        </h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
          {payment_type !== "ชำระเงินเชื่อ" &&
            params("type") !== "view" &&
            payment_type !== "ชำระครบแล้ว" && (
              <div className="rounded-4 bg-white p-3 mb-3">
                <div className="row">
                  <div className="col-12 col-md-6 mb-2">
                    <div className="d-flex align-items-center justify-content-between hpx-50">
                      <span>มูลค่าเต็มจำนวนสั่งซื้อ</span>
                      <b>
                        {(() => {
                          let total = 0;

                          if (transaction_list_vat?.length > 0) {
                            transaction_list_vat?.forEach((item) => {
                              const qty = Number(item.qty ?? 0);
                              const unitPrice = Number(item.unit_price ?? 0);
                              const itemDiscount = Number(item.discount ?? 0);
                              total += qty * (unitPrice - itemDiscount);
                            });
                          } else {
                            transaction_list?.forEach((item) => {
                              const qty = Number(item.qty ?? 0);
                              const unitPrice = Number(item.unit_price ?? 0);
                              const itemDiscount = Number(item.discount ?? 0);
                              total += qty * (unitPrice - itemDiscount);
                            });
                          }

                          if (isNaN(total)) total = 0;

                          const billDiscount = Number(discount ?? 0); // ส่วนลดทั้งบิล
                          const net = total - billDiscount;

                          const grandTotal = Number(net) + Number(vat);

                          return `${toFixed(grandTotal)}`;
                        })()}
                      </b>
                    </div>
                    <div className="d-flex align-items-center justify-content-between hpx-50">
                      <span>มูลค่าที่ชำระแล้ว</span>
                      <b>{toFixed(Number(total_pay))}</b>
                    </div>
                  </div>
                  <div className="col-12 col-md-6 mb-2">
                    <div className="d-flex align-items-center justify-content-between hpx-50">
                      <span>ชำระมัดจำ</span>
                      <input
                        type="text"
                        className="form-control text-end wpx-200 hpx-40"
                        placeholder="0.00"
                        onChange={(e) => {
                          if (!float(e.target.value)) return;
                          const nextAmountDeposit = e.target.value;
                          const billed = this.calcBilled();
                          const totalPay = Number(this.state.total_pay);
                          this.setState({
                            amount_deposit: nextAmountDeposit,
                            amount_deposit_need: this.calcDefaultPaymentNeed(
                              billed,
                              totalPay,
                              Number(nextAmountDeposit)
                            ),
                          });
                        }}
                        value={amount_deposit}
                        disabled={payment_type !== "ชำระมัดจำ" || total_pay > 0}
                      />
                    </div>
                    <div className="d-flex align-items-center justify-content-between hpx-50">
                      <span>ยอดเงินที่ต้องการชำระ</span>
                      <input
                        type="text"
                        className="form-control text-end wpx-200 hpx-40"
                        placeholder="0.00"
                        onChange={(e) => {
                          if (!float(e.target.value)) return;
                          this.setState({
                            amount_deposit_need: e.target.value,
                          });
                        }}
                        value={amount_deposit_need}
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}

          {payment_type !== "ชำระเงินเชื่อ" &&
            params("type") !== "view" &&
            payment_type !== "ชำระครบแล้ว" && (
              <div className="row mb-2">
                {/* ชำระเงินสด */}
                <div className="col-12 col-md-6 col-lg-4 mb-3">
                  <div
                    className="rounded-4 bg-white p-3"
                    style={{ height: "100%" }}
                  >
                    <h5 className="fw-bold mb-0">ชำระเงินสด</h5>
                    <hr />
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <span className="wpx-100">จำนวนเงิน</span>
                      <input
                        type="text"
                        className="form-control text-end"
                        placeholder="0.00"
                        onChange={(e) => {
                          if (!float(e.target.value)) return;
                          this.setState({ cash_amount: e.target.value });
                        }}
                        value={cash_amount}
                      />
                    </div>
                    {/* <div className="d-flex align-items-center justify-content-between mb-3">
                  <span className="wpx-100">เงินทอน</span>
                  <b>{toFixed(cash_amount || 0)} บาท</b>
                </div> */}
                  </div>
                </div>
                {/* ชำระเงินโอน */}
                <div className="col-12 col-md-6 col-lg-4 mb-3">
                  <div
                    className="rounded-4 bg-white p-3"
                    style={{ height: "100%" }}
                  >
                    <h5 className="fw-bold mb-0">ชำระเงินโอน</h5>
                    <hr />
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <span className="wpx-100">จำนวนเงิน</span>
                      <input
                        type="text"
                        className="form-control text-end"
                        placeholder="0.00"
                        onChange={(e) => {
                          if (!float(e.target.value)) return;
                          this.setState({ transfer_amount: e.target.value });
                        }}
                        value={transfer_amount}
                      />
                    </div>
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <span className="wpx-100">ธนาคาร</span>
                      <Select
                        options={data_bank}
                        className="form-control"
                        onChange={(e) => {
                          this.setState({ transfer_bank_account: e });
                        }}
                        value={transfer_bank_account}
                      />
                    </div>
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <span className="wpx-100">วันที่โอน</span>
                      <DatePicker
                        className="form-control"
                        onChange={(e) => {
                          this.setState({ transfer_date: e });
                        }}
                        value={transfer_date}
                      />
                    </div>
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <span className="wpx-100">เวลาที่โอน</span>
                      <input
                        type="time"
                        className="form-control"
                        onChange={(e) => {
                          this.setState({ transfer_time: e.target.value });
                        }}
                        value={transfer_time}
                      />
                    </div>
                  </div>
                </div>
                {/* ชำระเช็ค */}
                <div className="col-12 col-md-6 col-lg-4 mb-3">
                  <div
                    className="rounded-4 bg-white p-3"
                    style={{ height: "100%" }}
                  >
                    <h5 className="fw-bold mb-0">ชำระเช็ค</h5>
                    <hr />
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <span className="wpx-100">จำนวนเงิน</span>
                      <input
                        type="text"
                        className="form-control text-end"
                        placeholder="0.00"
                        onChange={(e) => {
                          if (!float(e.target.value)) return;
                          this.setState({ credit_amount: e.target.value });
                        }}
                        value={credit_amount}
                      />
                    </div>
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <span className="wpx-100">ธนาคาร</span>
                      <Select
                        options={global.bank}
                        className="form-control"
                        onChange={(e) => {
                          this.setState({ credit_bank_account: e });
                        }}
                        value={credit_bank_account}
                      />
                    </div>
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <span className="wpx-100">วันที่หน้าเช็ค</span>
                      <DatePicker
                        className="form-control"
                        onChange={(e) => {
                          this.setState({ credit_date: e });
                        }}
                        value={credit_date}
                      />
                    </div>
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <span className="wpx-100">เลขที่เช็ค</span>
                      <input
                        type="text"
                        className="form-control"
                        onChange={(e) => {
                          if (!float(e.target.value)) return;
                          this.setState({ check_number: e.target.value });
                        }}
                        value={check_number}
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}
          <div className="hpx-100"/>
          {(payment_type === "ชำระเงินเชื่อ" ||
            payment_type === "ชำระครบแล้ว") && <div className="hpx-100"></div>}
        </div>
        {params("type") !== "view" && (
          <div
            className="position-fixed w-100 bg-white d-flex justify-content-end p-3"
            style={{ bottom: 0, left: 0 }}
          >
            {payment_type === "ชำระครบแล้ว" && (
              <div className="px-3 py-0 border-2 border-danger text-20 fw-bold rounded-4 me-2 text-danger">
                ชำระครบแล้ว
              </div>
            )}
            <button
              className="btn btn-dark"
              onClick={() => {
                this.CreateUpdate();
              }}
            >
              {payment_type === "ชำระเงินเชื่อ" ? "บันทึก" : "รับชำระ"}
            </button>
          </div>
        )}
      </div>
    );
  }
}
